import { render, staticRenderFns } from "./Create_Manage.vue?vue&type=template&id=4edaa1b9"
import script from "./Create_Manage.vue?vue&type=script&lang=js"
export * from "./Create_Manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports